// embed.ts
/**
 * utility file for calling powerbi embedding and other utility functions
 */
//import * as $ from 'jquery';
/*import bootstrap = require("bootstrap");*/
import * as bootstrap from 'bootstrap'
import { IEmbedConfigurationBase } from "embed";
import * as powerbiclient from "powerbi-client";
import * as powerbimodels from "powerbi-models";

let powerbi = new powerbiclient.service.Service(powerbiclient.factories.hpmFactory, powerbiclient.factories.wpmpFactory, powerbiclient.factories.routerFactory);

/**
 * 
 * @param reportId ID of the powerbi report as returned by the api
 * @param embedUrl url of the powerbi report as returned by the api
 * @param token bearer token of the powerbi report as returned by the api
 * @param userType Type Organization | Customer
 * @returns powerbi embed configuration {@link }
 */
const getConfig = (reportId: string, embedUrl: string, token: string, userType: string) => {
    let config: powerbiclient.IReportEmbedConfiguration =
    {
        type: 'report',
        id: reportId,
        embedUrl: embedUrl,
        accessToken: token,
        permissions: powerbimodels.Permissions.All,
        tokenType: powerbimodels.TokenType.Embed,
        //tokenType:models.TokenType.Aad,
        viewMode: powerbimodels.ViewMode.View,
        settings: {
            panes: {
                filters: { expanded: false, visible: false },
                pageNavigation: { visible: false }
            },
            background: powerbimodels.BackgroundType.Transparent,
            layoutType: powerbimodels.LayoutType.Custom,
            customLayout: {
                displayOption: powerbimodels.DisplayOption.FitToPage
            }
        },
    }
    if (userType == "organization") {
        config.tokenType = powerbimodels.TokenType.Aad;
    }
    else {
        config.tokenType = powerbimodels.TokenType.Embed;
    }
    return config;

}
let reportContainerElement: HTMLElement;

export const preLoad = (embedUrl: string, reportContainer: string | HTMLElement) => {
    
    let config :IEmbedConfigurationBase = {
        type: 'report',
        embedUrl: 'https://app.powerbi.com/reportEmbed',
        settings: {
            panes: {
                filters: { expanded: false, visible: false },
                pageNavigation: { visible: false }
            },
            background: powerbimodels.BackgroundType.Transparent,
            layoutType: powerbimodels.LayoutType.Custom,
            customLayout: {
                displayOption: powerbimodels.DisplayOption.FitToPage
            },
            
        },
    };
    powerbi.preload(config);
    reportContainerElement = (typeof reportContainer == "string") ? document.getElementById(reportContainer) : reportContainer;
    powerbi.bootstrap(
        reportContainerElement,
        {
            type: 'report'
        }
    );
    let iframes = document.getElementsByTagName("iframe");
    for (var i = 0; i < iframes.length; i++) {
        iframes[i].title = `report-iframe-${i}`;
    }
}
//https://learn.microsoft.com/en-us/power-bi/developer/embedded/embed-organization-app
/**
 * Renders a PowerBI report with the parameters provided and returns a powerbiclient.Report object
 * @param reportContainer HTML element reference of id housing the PowerBI Report
 * @param reportId ID of the powerbi report as returned by the api
 * @param embedUrl url of the powerbi report as returned by the api
 * @param token bearer token of the powerbi report as returned by the api
 * @param userType Type Organization | Customer
 * @param dotNetObjectReference optional reference to razor page calling this method
 * @param callbackRenderedFunctionName optional function name to call in .net after report renders
 * @returns
 */
export const renderReport = (reportContainer: string | HTMLElement, reportId: string, embedUrl: string, token: string, userType: string, dotNetObjectReference?: DotNet.DotNetObject,
    callbackRenderedFunctionName?: string):powerbiclient.Report => {

    let config = getConfig(reportId, embedUrl, token, userType)
    try {
        powerbi.reset(reportContainerElement);
    } catch (e) {
        console.error(e);
    }
    
    let report = powerbi.load(reportContainerElement, config) as powerbiclient.Report;
    report.on("loaded", async (ev) => {
        await report.render();
    });
    report.on("rendered", async (ev) => {
        if (dotNetObjectReference && callbackRenderedFunctionName) {
            (await report.getFilters()).forEach((f) => { console.log(f); });
            let pages = await report.getPages();
            let returnPages = pages.map(function (page) {
                return { name: page.name, displayName: page.displayName, isActive: page.isActive, visibility: page.visibility };

            });
            await dotNetObjectReference.invokeMethodAsync(callbackRenderedFunctionName, returnPages);
        }
    });
    return report;
}
export const resetReport = (reportContainer: string | HTMLElement) => {
    let reportContainerElement: HTMLElement = (typeof reportContainer == "string") ? document.getElementById(reportContainer) : reportContainer;
    let powerbi = new powerbiclient.service.Service(powerbiclient.factories.hpmFactory, powerbiclient.factories.wpmpFactory, powerbiclient.factories.routerFactory);
    powerbi.reset(reportContainerElement);
}
/**
 * Generates an avatar taking the initials of a string
 * @param name the name to change to an avatar
 * @returns a Data Url to embed in an img element
 */
export const generateAvatar = (name: string): string => {
    let initials = name.split(' ').map(function (str) { return str ? str[0].toUpperCase() : ""; }).join('');
    let canvas = document.createElement('canvas');
    let radius = 30.0;
    let margin = 0.0;
    canvas.width = radius * 2 + margin * 2;
    canvas.height = radius * 2 + margin * 2;

    // Get the drawing context
    let ctx = canvas.getContext('2d');
    ctx.beginPath();
    ctx.arc(radius + margin, radius + margin, radius, 0, 2 * Math.PI, false);
    ctx.closePath();
    ctx.fillStyle = "#F7F0FF";
    ctx.fill();
    ctx.fillStyle = "#8E6ABF";
    ctx.font = "bold 30px Arial";
    ctx.textAlign = 'center';
    ctx.fillText(initials, radius + 1, radius * 4 / 3 + margin);
    return canvas.toDataURL();
}

/**
 * Gets the adjusted heights of the element on resizing
 * @returns new height in pixels
 */
export const getAdjustedHeights = (): string => {
    let heightBuffer = 75;
    let toprow = document.getElementsByClassName("top-row")[0] as HTMLElement;
    let footer = document.getElementsByTagName("footer")[0];
    //debugger;
    let newHeight = document.documentElement.offsetHeight - (toprow.offsetHeight + footer.offsetHeight + heightBuffer);
    return `${newHeight}px`;
}

document.addEventListener("DOMContentLoaded", () => {
    let tooltips: bootstrap.Tooltip[] = [];
    bootstrap.Tooltip.Default.allowList.dl = [];
    bootstrap.Tooltip.Default.allowList.dt = [];
    bootstrap.Tooltip.Default.allowList.dd = [];

    window.addEventListener("load", () => {
        let tooltip = new bootstrap.Tooltip(document.body, {
            selector: '[data-bs-toggle="tooltip"],[rel="tooltip"]',
            container: "body",
            trigger: "hover"
        });
        tooltips.push(tooltip);
    });
});
window.bootstrap = require("bootstrap");